<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="550"
  >
    <v-card>
      <v-card-title v-if="title != ''">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="msg != ''">
        {{ msg }}
      </v-card-text>
      <v-card-subtitle v-if="subtitle != ''">
        {{ subtitle }}
      </v-card-subtitle>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="btnTxt1 != ''"
          color="success"
          text
          @click="btnClicked(1)"
        >
          {{ btnTxt1 }}
        </v-btn>
        <v-btn
          v-if="btnTxt2 != ''"
          color="warning"
          text
          @click="btnClicked(2)"
        >
          {{ btnTxt2 }}
        </v-btn>
        <v-btn
          v-if="btnTxt3 != ''"
          text
          @click="btnClicked(3)"
        >
          {{ btnTxt3 }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    btnTxt1: {
      type: String,
      default: "",
    },
    btnTxt2: {
      type: String,
      default: "",
    },
    btnTxt3: {
      type: String,
      default: "",
    },
    msg: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      response: 0,
      show: false,
    };
  },
  methods: {
    btnClicked(val) {
      this.response = val;
      this.closeDialog();
    },
    closeDialog() {
      this.show = false;
    },
    openDialog() {
      this.reset();
      this.show = true;
    },
    reset() {
      this.response = -1;
    },
  },
};
</script>

<style></style>
